import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  CreateProps,
  ListButton,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { DeviceCategoryDto } from '../../core/dto/device-category/device-category.dto'
import { CreateNode } from '../../lib/@react-admin/ra-tree/esm/src'

const validateDeviceCategoryCreate = (values: DeviceCategoryDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.name) {
    errors.name = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.device-categories.titles.create')}</span>
}

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

interface CreateNodeProps extends CreateProps {
  syncWithLocation?: boolean
}

export const DeviceCategoryCreate = ({
  //TreeWithDetails' props include syncWithLocation variable, which generates error when we pass it over to EditNode
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  syncWithLocation,
  ...props
}: CreateNodeProps) => (
  <CreateNode {...props} title={<CreateTitle />}>
    <SimpleForm
      redirect="show"
      validate={validateDeviceCategoryCreate}
      toolbar={<CreateToolbar />}
    >
      <TextInput source="name" isRequired />
    </SimpleForm>
  </CreateNode>
)
